import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { IncidentTicketDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/incident-ticket-dialog/incident-ticket-dialog.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { VisitorTickets } from 'src/app/models/tickets';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { IAnalyticsState } from 'src/app/state-management/states/aumye-analytics.state';

@Component({
  selector: 'app-incident-analytics-container',
  templateUrl: './incident-analytics-container.component.html',
  styleUrls: ['./incident-analytics-container.component.scss'],
})
export class IncidentAnalyticsContainerComponent {
  @Input() set analyticsData(val: IAnalyticsState) {
    if (val) {
      this.incidentTickets = val.incidentTickets;
    }
  }
  @Output() createIncidentTicket = new EventEmitter<any>();
  incidentTickets: VisitorTickets[];
  screenSize: ScreenType;
  constructor(
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  onAddTicket() {
    const dialogRef = this.dialog.open(IncidentTicketDialogComponent, {
      disableClose: true,
      data: '',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.createIncidentTicket.emit(result);
      }
    });
  }
  getFormatedDateTime(val: string) {
    let formatedDate = moment(val, 'YYYY-MM-DDTHH:mm:ss.SSS').fromNow();
    return formatedDate;
  }
  ScreenType = ScreenType;
}
